import { Record, fromJS } from 'immutable';

export default class FileRecord extends Record({
  id: null,
  name: null,
  // size: null, // you can't use size as a field name for Immutable Records
  mimeType: null,
  createdAt: null,
  createdBy: null,
  links: null,
}) {
  constructor(values) {
    const record = super(fromJS(values));
    return record;
  }
}
